<div class="flex flex-col items-center">
  <img style="width: auto" src="/assets/images/letter_box.svg" />
  <div class="title">Brak powiadomień</div>
  <div class="content">
    Nie masz obecnie żadnych powiadomień. <br />
  </div>
</div>
